import { API } from "../api/API";
import { validateResponseStatus } from "../utils";

export const getAll = async (token, logOut) => {
  const result = await API()
    .get("academy/business/all")
    .catch((error) => {
      return error.response ? error.response : { error };
    });

  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};
